<template>
  <div>
    <el-row class="week-calendar">
      <div class="month-selector">
        <el-col :span="2">
          <button class="nav-btn" :disabled="isLoading" @click="prevWeek">
            <template>
              <font-awesome-icon :icon="['far', 'chevron-down']" font-size="24px" cursor="pointer" style="transform:rotate(90deg)" />
            </template>
          </button>
        </el-col>
        <el-col :span="3" />
        <el-col :span="13">
          <el-date-picker v-model="selectedDate" type="date" format="yyyy 年 MM 月" value-format="yyyy-MM-dd" placeholder="選擇日期" class="date-picker" @change="onDateChange" />
        </el-col>
        <el-col :span="4">
          <el-button type="text" :disabled="isLoading" @click="goToday">Today</el-button>
        </el-col>
        <el-col :span="2">
          <button class="nav-btn" :disabled="isLoading" @click="nextWeek">
            <template>
              <font-awesome-icon :icon="['far', 'chevron-down']" font-size="24px" cursor="pointer" style="transform:rotate(270deg)" />
            </template>
          </button>
        </el-col>
      </div>
    </el-row>
    <el-row>
      <el-col :span="3" v-for="day in currentWeek" :key="day.date" :class="['day-box', { selected: isSelected(day.date), 'is-today': day.date === todayDateString }]" style="margin:0px 6px">
        <div class="day-number">{{ day.day }}</div>
        <div class="day-week">{{ day.week }}</div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

export default {
  name: 'hotelCalendarComponent',
  components: {
    FontAwesomeIcon,
  },
  props: {
    isLoading: {
      type: Boolean,
      default: false,
    },
    initialDate: {
      type: String,
      default: '',
    },
  },
  watch: {
    selectedDate: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.emitWeekRange()
        }
      },
    },
    initialDate: {
      handler(val) {
        if (val) {
          this.syncCalendarToDate(val)
        }
      },
    },
  },
  created() {
    if (this.initialDate) {
      this.syncCalendarToDate(this.initialDate)
    }
  },
  data() {
    const today = new Date()
    const seed = this.initialDate ? new Date(String(this.initialDate).replace(/-/g, '/')) : today
    const base = Number.isNaN(seed.getTime()) ? today : seed
    return {
      todayDateString: this.formatDate(today),
      selectedDate: this.formatDate(base),
      baseDate: this.getMonday(base),
      selectedWeekday: base.getDay() === 0 ? 7 : base.getDay(),
    }
  },
  computed: {
    currentWeek() {
      const days = []
      const weekMap = ['日', '一', '二', '三', '四', '五', '六']
      for (let i = 0; i < 7; i++) {
        const d = new Date(this.baseDate)
        d.setDate(d.getDate() + i)
        days.push({
          date: this.formatDate(d),
          day: d.getDate(),
          week: weekMap[d.getDay()],
        })
      }
      return days
    },
    startOfWeek() {
      if (!this.selectedDate) return ''
      const date = new Date(this.selectedDate)
      const day = date.getDay() // 0 (日) 到 6 (六)
      const diff = date.getDate() - day + (day === 0 ? -6 : 1)
      const monday = new Date(date.setDate(diff))
      return this.formatDate(monday)
    },
    endOfWeek() {
      if (!this.startOfWeek) return ''
      const monday = new Date(this.startOfWeek)
      const sunday = new Date(monday.setDate(monday.getDate() + 6))
      return this.formatDate(sunday)
    },
  },
  methods: {
    formatDate(date) {
      const y = date.getFullYear()
      const m = this.pad(date.getMonth() + 1)
      const d = this.pad(date.getDate())
      return `${y}-${m}-${d}`
    },
    pad(n) {
      return n < 10 ? '0' + n : n
    },
    getMonday(date) {
      const d = new Date(date)
      const day = d.getDay()
      const diff = day === 0 ? -6 : 1 - day
      d.setDate(d.getDate() + diff)
      return d
    },
    syncCalendarToDate(dateStr) {
      const date = new Date(String(dateStr).replace(/-/g, '/'))
      if (Number.isNaN(date.getTime())) return
      this.selectedDate = this.formatDate(date)
      this.baseDate = this.getMonday(date)
      this.selectedWeekday = date.getDay() === 0 ? 7 : date.getDay()
    },
    onDateChange(val) {
      this.syncCalendarToDate(val)
    },
    isSelected(dateStr) {
      return this.selectedDate === dateStr
    },
    prevWeek() {
      const d = new Date(this.baseDate)
      d.setDate(d.getDate() - 7)
      this.baseDate = d

      const newDate = new Date(d)
      newDate.setDate(newDate.getDate() + this.selectedWeekday - 1)
      this.selectedDate = this.formatDate(newDate)
    },
    nextWeek() {
      const d = new Date(this.baseDate)
      d.setDate(d.getDate() + 7)
      this.baseDate = d

      const newDate = new Date(d)
      newDate.setDate(newDate.getDate() + this.selectedWeekday - 1)
      this.selectedDate = this.formatDate(newDate)
    },
    goToday() {
      const today = new Date()
      this.selectedDate = this.formatDate(today)
      this.baseDate = this.getMonday(today)
      this.selectedWeekday = today.getDay() === 0 ? 7 : today.getDay()
    },
    emitWeekRange() {
      this.$emit('week-change', {
        start: this.startOfWeek,
        end: this.endOfWeek,
      })
    },
  },
}
</script>

<style scoped lang="scss">
.week-calendar {
  font-family: 'Helvetica', sans-serif;
}
.month-selector {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 16px;
  text-align: center;
}
.nav-btn {
  background: none;
  border: none;
  font-size: 18px;
  cursor: pointer;
  color: #6c6b6b;
  & :hover {
    color: #ea6a2a;
  }
}
.day-box {
  border-radius: 6px;
  pointer-events: none;
  background-color: #ffffff;
}
.day-number {
  font-size: 20px;
  font-weight: bold;
  display: inline-block;
  width: 32px;
  height: 32px;
  line-height: 32px;
  border-radius: 50%;
  color: #121931;
}

.is-today .day-number {
  border-color: #ea6a2a;
  color: #ea6a2a;
}

.selected .day-number {
  background-color: #ea6a2a;
  color: white;
}

.is-today.selected .day-number {
  border-color: #ea6a2a;
  color: white;
}
.day-week {
  font-size: 14px;
  color: #6c6b6b;
}

.date-picker {
  ::v-deep .el-input__inner {
    font-size: large;
    text-align: center;
    color: #121931;
    background-color: #f2f2f2;
  }
  ::v-deep .el-icon-date:before {
    font-size: large;
  }
}
</style>
